import { EJavaClassNames } from '@adaptiva/data-service';
import { MetadataSerialization, ProductProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-product-properties',
	templateUrl: './product-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPropertiesComponent extends BaseAuthoringPropertiesComponent<ProductProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<ProductProperties> = ProductProperties;

	protected readonly scheduleClassName: EJavaClassNames = EJavaClassNames.Schedule;

	protected readonly maintenanceWindowClassName: EJavaClassNames = EJavaClassNames.MaintenanceWindow;

}
